import React, { useState } from 'react'
import { updateRoom } from '../../../adapters/conversation';
import { updateData } from '../../../requests/chat';
import SuccessStatus, { ErrorStatus } from '../../FormStatus'
import { FileInput, InputField } from '../../Input';

export default function EditModal({ chat, setChatRecord, user, onClose}) {
    const [formState, setFormState] = useState({
        title: chat?.title,
        members: chat?.members,
        icon: null,
        statue: false,
        message: 'Chat updated successfully!'
    })
    const [ errors, setErrors ] = useState([]);
    const [ icon, setIcon] = useState(chat?.icon)

    const handleInputChange = (name, value) => {
        setErrors([]);
        if (name === 'icon') {
            setIcon(URL.createObjectURL(value));    
        } 
        formState[name] = value;
        setFormState(formState);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = {
            title: formState.title,
            icon: formState.icon,
            members: Array.from(formState.members).map((ch) => ch._id),
        };

        await updateData.validate(data).then(async () => {
            try {
                await updateRoom(data, chat._id).then((res) => {
                    if(res.status === 200) {
                        setChatRecord(res.data);
                    }else{
                        setErrors(['failed to update chat room'])
                    }
                })
            } catch (e) {
                setErrors(['failed to update chat room'])
            }
        }).catch((err) => {
            setErrors(err.errors)
        })
    }

  return (
    <div onClick={onClose} className="fixed z-50 animate__animated animate__fadeIn w-screen h-screen modal-dialog-bg-dark shadow-md md:px-8 px-4 left-0 top-0">
        <div className="relative w-full flex h-full justify-center items-center">
            <div onClick={(e) => {
                e.stopPropagation();
            }} onBlur={onClose} className="lg:w-2/5 relative mt-8 px-8 w-full bg-white py-8 rounded-xl">
                <h4 className="mb-3 text-sm font-semibold">
                    Edit Chat
                </h4>
                <div className="mt-3">
                    <ErrorStatus errors={errors} />
                    <SuccessStatus message={formState.message} showStatus={formState.status} />
                    <form onSubmit={handleSubmit}>
                        <div className="mt-4 mb-4">
                            <div className="flex itmes-center justify-center mb-4">
                                <img src={icon} className='border-2 border-gray-600 rounded-full h-24 w-24' alt="icon" />
                            </div>
                            <FileInput id="icon" fileType="image/*" onChange={(e) => {
                                handleInputChange('icon', e.target.files[0])
                            }} name='icon' value={formState.icon} label="Change Icon" isRequired={false} />


                            <InputField
                                onChange={(e) => {
                                    handleInputChange('title',e.target.value)
                                }} 
                                isRequired={true} type="text" placeholder="Enter Chat Room Title" name="title" defaultValue={formState.title} label="Room Title" 
                            />
                            
                            <button className="w-full py-2 flex justify-center items center border-2 border-blue-800 text-white font-semibold text-sm bg-blue-800 hover:bg-blue-900 rounded-lg ">
                                <span>
                                    Update Room
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}
